(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    var track = bar.querySelector('[data-kh-ann-track]');
    var group = track && track.querySelector('.kh-ann-group');
    if (!group) return;
    if (bar.dataset.pause === 'true') bar.classList.add('kh-ann--paused');
    // keep a constant speed (pixels per second) no matter how long the messages are
    function setDuration() {
      var pxPerSec = parseInt(bar.dataset.speed, 10) || 50;
      track.style.setProperty('--kh-ann-dur', (group.offsetWidth / pxPerSec) + 's');
    }
    setDuration();
    window.addEventListener('resize', setDuration);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setDuration);
  }
  document.querySelectorAll('[data-kh-ann]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-kh-ann]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__khHeaderInit) return;
  window.__khHeaderInit = true;

  document.querySelectorAll('.kh-menu').forEach(function (menu) {
    // move to <body> so theme wrappers can't break fixed positioning
    document.body.appendChild(menu);

    var backdrop = menu.querySelector('.kh-menu-backdrop');
    var panel = menu.querySelector('.kh-menu-panel');
    var opener = document.querySelector('[data-kh-menu-open]');

    // forced inline styles so theme CSS can't hide the backdrop
    backdrop.style.setProperty('position', 'fixed', 'important');
    backdrop.style.setProperty('inset', '0', 'important');
    backdrop.style.setProperty('background', 'rgba(0, 0, 0, 0.5)', 'important');
    backdrop.style.setProperty('opacity', '0', 'important');
    backdrop.style.setProperty('pointer-events', 'none', 'important');
    backdrop.style.setProperty('transition', 'opacity 0.3s ease', 'important');
    backdrop.style.setProperty('z-index', '2000', 'important');
    backdrop.style.setProperty('display', 'block', 'important');
    panel.style.setProperty('z-index', '2001', 'important');

    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      backdrop.style.setProperty('pointer-events', 'auto', 'important');
      requestAnimationFrame(function () { backdrop.style.setProperty('opacity', '1', 'important'); });
    }
    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      backdrop.style.setProperty('opacity', '0', 'important');
      backdrop.style.setProperty('pointer-events', 'none', 'important');
    }

    if (opener) opener.addEventListener('click', open);
    menu.querySelectorAll('[data-kh-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 750) close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-order-updates"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.kuBound) return;
    root.dataset.kuBound = '1';
    root.querySelectorAll('[data-ku-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    });
  }
  document.querySelectorAll('[data-ku]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-ku]').forEach(init); });
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target.querySelector && e.target.querySelector('[data-ku-toggle]');
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-password"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (root.dataset.kpwBound) return;
    root.dataset.kpwBound = '1';

    /* countdown */
    var target = Date.parse(root.dataset.target);
    var els = { d: root.querySelector('[data-kpw-d]'), h: root.querySelector('[data-kpw-h]'), m: root.querySelector('[data-kpw-m]'), s: root.querySelector('[data-kpw-s]') };
    var liveTpl = root.querySelector('[data-kpw-live]');
    var wentLive = false;
    function goLive() {
      if (wentLive) return;
      wentLive = true;
      root.classList.add('is-live');
      if (liveTpl) {
        var t = liveTpl.content.querySelector('[data-title]');
        var s = liveTpl.content.querySelector('[data-sub]');
        var title = t ? t.textContent : '', sub = s ? s.textContent : '';
        function set(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }
        set('[data-kpw-banner-title]', title);
        set('[data-kpw-banner-sub]', sub);
        set('[data-kpw-big]', title);
        set('[data-kpw-tagline]', sub);
        var coming = root.querySelector('[data-kpw-coming]');
        if (coming) coming.hidden = true;
      }
    }
    function tick() {
      if (isNaN(target)) return;
      var diff = Math.max(0, target - Date.now());
      var sec = Math.floor(diff / 1000);
      els.d.textContent = pad(Math.floor(sec / 86400));
      els.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      els.m.textContent = pad(Math.floor(sec % 3600 / 60));
      els.s.textContent = pad(sec % 60);
      if (diff === 0) {
        var already = wentLive;
        goLive();
        // reload once at drop time so shoppers land in the store as soon as you remove the password
        if (!already && root.dataset.autoreload === 'true' && !sessionStorage.getItem('kpw-reloaded')) {
          sessionStorage.setItem('kpw-reloaded', '1');
          setTimeout(function () { location.reload(); }, 1500);
        }
      }
    }
    tick();
    setInterval(tick, 1000);

    /* Postscript SMS signup */
    var sms = root.querySelector('[data-kpw-sms]');
    if (sms) {
      var phone = sms.querySelector('input[name="phone"]');
      var btn = sms.querySelector('button[type="submit"]');
      var frame = root.querySelector('[data-kpw-sms-frame]');
      var ok = root.querySelector('[data-kpw-sms-success]');
      var err = root.querySelector('[data-kpw-sms-error]');
      var sent = false;
      function done() {
        if (!sent) return;
        sms.hidden = true;
        if (ok) ok.hidden = false;
      }
      var cc = sms.querySelector('[data-kpw-cc]');
      sms.addEventListener('submit', function (e) {
        var raw = phone.value.trim();
        var clean;
        if (raw.charAt(0) === '+') {
          clean = '+' + raw.replace(/\D/g, '');                    // shopper typed a full international number
        } else {
          var code = cc ? cc.value : '1';
          var local = raw.replace(/\D/g, '');
          if (code === '1' && local.length === 11 && local.charAt(0) === '1') local = local.slice(1);
          if (code !== '1') local = local.replace(/^0+/, '');       // drop the national leading 0 (e.g. UK 07...)
          clean = '+' + code + local;
        }
        var digits = clean.replace(/\D/g, '');
        if (digits.length < 8 || digits.length > 15) {
          e.preventDefault();
          if (err) err.hidden = false;
          phone.focus();
          return;
        }
        if (err) err.hidden = true;
        phone.value = clean;                                         // send the cleaned number to Postscript
        sent = true;
        setTimeout(function () { btn.disabled = true; }, 0);
        if (frame) frame.addEventListener('load', done, { once: true });
        setTimeout(done, 2500);
      });
    }

    /* password popup */
    var modal = root.querySelector('[data-kpw-modal]');
    document.body.appendChild(modal);
    var input = modal.querySelector('input[name="password"]');
    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); setTimeout(function () { input && input.focus(); }, 50); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    root.querySelectorAll('[data-kpw-open]').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-kpw-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (modal.querySelector('[data-kpw-has-error]')) open();
  }

  document.querySelectorAll('[data-kpw]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-kpw]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatMoney(cents, format) {
    var value = cents / 100, whole = cents % 100 === 0;
    function sep(n, d, t, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return sep(value, whole ? 0 : 2, '.', ',');
      if (k === 'amount_no_decimals') return sep(value, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return sep(value, 0, '.', ',');
      return sep(value, whole ? 0 : 2, ',', '.');
    });
  }

  function initProduct(root) {
    if (root.dataset.kpBound) return;
    root.dataset.kpBound = '1';

    var variants = JSON.parse(root.querySelector('[data-kp-variants]').textContent);
    var moneyFormat = JSON.parse(root.querySelector('[data-kp-money]').textContent);
    var variantMedia = {};
    try { variantMedia = JSON.parse(root.querySelector('[data-kp-variant-media]').textContent.replace(/,\s*}/, '}')); } catch (e) {}
    var variantStock = {};
    try { variantStock = JSON.parse(root.querySelector('[data-kp-variant-stock]').textContent.replace(/,\s*}/, '}')); } catch (e) {}

    /* recently viewed log */
    try {
      var handle = JSON.parse(root.querySelector('[data-kp-recent]').textContent);
      var list = JSON.parse(localStorage.getItem('kesahu_recent') || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem('kesahu_recent', JSON.stringify(list.slice(0, 12)));
    } catch (e) {}

    /* gallery */
    var slides = root.querySelector('[data-kp-slides]');
    var slideEls = root.querySelectorAll('[data-kp-slide]');
    var thumbs = root.querySelectorAll('[data-kp-thumb]');
    var bar = root.querySelector('[data-kp-progress]');
    var active = 0;
    function goTo(i) {
      if (!slides || !slideEls.length) return;
      i = Math.max(0, Math.min(slideEls.length - 1, i));
      slides.scrollTo({ left: slideEls[i].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      active = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
    }
    if (slides) {
      var raf;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(slides.scrollLeft / slides.clientWidth);
          if (i !== active) setActive(i);
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.kpThumb, 10)); }); });

    /* zoom */
    var zoom = document.getElementById('kp-zoom-' + root.id.slice(3));
    if (zoom) {
      document.body.appendChild(zoom);
      var zImg = zoom.querySelector('[data-kp-zoom-img]');
      function closeZoom() { zoom.classList.remove('is-open'); zoom.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
      root.querySelectorAll('[data-kp-zoom-src]').forEach(function (img) {
        img.addEventListener('click', function () {
          zImg.src = img.dataset.kpZoomSrc; zImg.alt = img.alt || '';
          zoom.classList.add('is-open'); zoom.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
        });
      });
      zoom.addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }

    /* tabs */
    root.querySelectorAll('[data-kp-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-kp-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          group.querySelectorAll('[data-kp-panel]').forEach(function (p) { p.hidden = p.dataset.kpPanel !== tab.dataset.kpTab; });
        });
      });
    });

    /* variants */
    var optionEls = root.querySelectorAll('[data-kp-option]');
    if (!optionEls.length) return;
    var pointsRate = parseFloat(root.dataset.points) || 0;

    function selected() {
      return Array.prototype.map.call(optionEls, function (el) { var s = el.querySelector('.kp-value.is-selected'); return s ? s.dataset.kpValue : null; });
    }
    function match(opts, mustBeAvailable) {
      return variants.find(function (v) { return (!mustBeAvailable || v.available) && v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function refreshAvailability(opts) {
      optionEls.forEach(function (el, pos) {
        el.querySelectorAll('.kp-value').forEach(function (btn) {
          var test = opts.slice(); test[pos] = btn.dataset.kpValue;
          btn.classList.toggle('is-unavailable', !match(test, true));
        });
      });
    }
    function update() {
      var opts = selected(), v = match(opts, false);
      refreshAvailability(opts);
      optionEls.forEach(function (el, i) {
        var l = el.querySelector('[data-kp-option-value]');
        if (l) l.textContent = (v && v.available) ? (opts[i] || '') : '';
      });
      var idInput = root.querySelector('[data-kp-variant-id]');
      var add = root.querySelector('[data-kp-add]');
      var price = root.querySelector('[data-kp-price]');
      var compare = root.querySelector('[data-kp-compare]');
      var dot = root.querySelector('[data-kp-stock-dot]');
      var stockText = root.querySelector('[data-kp-stock-text]');
      var points = root.querySelector('[data-kp-points]');
      if (!v) { if (add) { add.disabled = true; add.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (price) price.textContent = formatMoney(v.price, moneyFormat);
      if (compare) { var sale = v.compare_at_price > v.price; compare.hidden = !sale; if (sale) compare.textContent = formatMoney(v.compare_at_price, moneyFormat); }
      if (points && pointsRate) points.textContent = Math.floor(v.price / 100) * pointsRate;
      var lowEl = root.querySelector('[data-kp-stock-low]');
      var lowLimit = lowEl ? (parseInt(lowEl.dataset.limit, 10) || 5) : 5;
      var qty = variantStock[String(v.id)];
      var state = !v.available ? 'out' : (typeof qty === 'number' && qty > 0 && qty <= lowLimit ? 'low' : 'in');
      if (dot) {
        dot.classList.remove('is-in', 'is-low', 'is-out');
        dot.classList.add('is-' + state);
      }
      if (stockText) {
        var src = root.querySelector('[data-kp-stock-' + state + ']');
        if (src) stockText.textContent = src.textContent;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      var mid = variantMedia[String(v.id)];
      if (mid) slideEls.forEach(function (s, i) { if (String(s.dataset.mediaId) === String(mid)) goTo(i); });
    }
    optionEls.forEach(function (el) {
      el.querySelectorAll('.kp-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          el.querySelectorAll('.kp-value').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });
    refreshAvailability(selected());
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-kp]').forEach(initProduct); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, format) {
    var v = cents / 100, whole = cents % 100 === 0;
    var s = v.toFixed(whole ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, s);
  }
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function card(p, cartUrl, fmt) {
    var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    var imgs = (p.images || []).slice(0, 2);
    var imgHtml = imgs.map(function (src, i) {
      return '<img class="saf-card-img' + (i === 0 ? ' is-active' : '') + '" data-saf-img-index="' + i + '" src="' + sized(src, 800) + '" alt="' + esc(p.title) + '" loading="lazy">';
    }).join('');
    var price = p.compare_at_price > p.price
      ? '<s class="saf-price-compare">' + money(p.compare_at_price, fmt) + '</s>' + money(p.price, fmt)
      : money(p.price, fmt);
    return '' +
      '<div class="saf-card' + (p.available ? '' : ' saf-card--sold-out') + '" data-saf-card>' +
        '<div class="saf-card-media" data-saf-media data-href="' + esc(p.url) + '" data-image-count="' + imgs.length + '">' +
          '<a href="' + esc(p.url) + '" class="saf-card-media-link" aria-label="' + esc(p.title) + '"></a>' +
          (p.available ? '' : '<span class="saf-badge saf-badge--sold-out">Sold Out</span>') +
          imgHtml +
          '<form method="post" action="' + esc(cartUrl) + '" class="saf-quick-add">' +
            '<input type="hidden" name="id" value="' + first.id + '">' +
            '<button type="submit" class="saf-quick-add-btn" aria-label="Add ' + esc(p.title) + ' to cart"' + (p.available ? '' : ' disabled') + '>' +
              '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</form>' +
        '</div>' +
        '<div class="saf-card-info">' +
          '<a href="' + esc(p.url) + '" class="saf-card-title-row"><span class="saf-card-title">' + esc(p.title) + '</span><span class="saf-card-price">' + price + '</span></a>' +
        '</div>' +
      '</div>';
  }
  function bind(scope) {
    if (window.kesahuBindCards) return window.kesahuBindCards(scope);
    scope.querySelectorAll('[data-saf-media]').forEach(function (m) {
      m.addEventListener('click', function (e) {
        if (e.target.closest('.saf-quick-add')) return;
        window.location.href = m.dataset.href;
      });
    });
  }
  function init(sec) {
    if (sec.dataset.krBound) return;
    sec.dataset.krBound = '1';
    var list = [];
    try { list = JSON.parse(localStorage.getItem('kesahu_recent') || '[]'); } catch (e) {}
    var current = sec.dataset.current;
    var limit = parseInt(sec.dataset.limit, 10) || 4;
    list = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!list.length) return;
    var root = (sec.dataset.root || '/').replace(/\/$/, '');
    var fmt = JSON.parse(sec.querySelector('[data-kr-money]').textContent);
    Promise.all(list.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      var row = sec.querySelector('[data-kr-recent-row]');
      row.innerHTML = products.map(function (p) { return card(p, sec.dataset.cartUrl, fmt); }).join('');
      sec.hidden = false;
      bind(row);
    });
  }
  function run() { document.querySelectorAll('[data-kr-recent]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-kr-recent]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kesahu-wear-it-with"] && !Shopify.designMode) return;
  try {
    
/* Shared helper: wires up product cards that are added after the page loads (used by Recently Viewed). */
(function () {
  if (window.kesahuBindCards) return;
  window.kesahuBindCards = function (scope) {
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    scope.querySelectorAll('[data-saf-media]').forEach(function (m) {
      m.addEventListener('click', function (e) {
        if (e.target.closest('.saf-quick-add')) return;
        if (m.dataset.href) window.location.href = m.dataset.href;
      });
      var imgs = m.querySelectorAll('[data-saf-img-index]');
      if (!canHover || imgs.length < 2) return;
      m.addEventListener('mouseenter', function () { imgs[0].classList.remove('is-active'); imgs[1].classList.add('is-active'); });
      m.addEventListener('mouseleave', function () { imgs[1].classList.remove('is-active'); imgs[0].classList.add('is-active'); });
    });
  };
})();

  } catch(e) { console.error(e); }
})();
})();
